export const FILE_STATUS = {
  UNKNOWN: -1,
  DONE: 0,
  IN_PROGRESS: 1,
  FILE_NOT_FOUND: 2,
  ERROR_AI: 3,
  ERROR_NO_MODEL: 4,
  ERROR_JSON: 5,
  ERROR_AI_THROTTLE: 6,
  ERROR_CONTENT_FILTER: 7,
  MODEL_DISABLED: 10,
  ERROR_TIMEOUT: 11,
  ERROR_NOT_SUPPORTED: 98,
  ERROR_OTHER: 99,
  OTHER: 100,
};

const NON_ERROR_STATUS_CODES = new Set([
  FILE_STATUS.DONE,
  FILE_STATUS.IN_PROGRESS,
]);

const STATUS_TRANSLATION_KEYS = {
  [FILE_STATUS.FILE_NOT_FOUND]: 'event_status.file_not_found',
  [FILE_STATUS.ERROR_AI]: 'event_status.error_ai',
  [FILE_STATUS.ERROR_NO_MODEL]: 'event_status.error_no_model',
  [FILE_STATUS.ERROR_JSON]: 'event_status.error_json',
  [FILE_STATUS.ERROR_AI_THROTTLE]: 'event_status.error_ai_throttle',
  [FILE_STATUS.ERROR_CONTENT_FILTER]: 'event_status.error_content_filter',
  [FILE_STATUS.MODEL_DISABLED]: 'event_status.model_disabled',
  [FILE_STATUS.ERROR_TIMEOUT]: 'event_status.error_timeout',
  [FILE_STATUS.ERROR_NOT_SUPPORTED]: 'event_status.error_not_supported',
  [FILE_STATUS.ERROR_OTHER]: 'event_status.error_other',
  [FILE_STATUS.OTHER]: 'event_status.error_other',
  [FILE_STATUS.UNKNOWN]: 'event_status.error_other',
};

const parseStatus = (status) => {
  if (status === null || status === undefined) {
    return NaN;
  }

  const numericStatus = Number(status);
  return Number.isFinite(numericStatus) ? numericStatus : NaN;
};

export const isErrorStatus = (status) => {
  const numericStatus = parseStatus(status);
  if (Number.isNaN(numericStatus)) {
    return false;
  }

  return !NON_ERROR_STATUS_CODES.has(numericStatus);
};

export const getErrorStatusTranslationKey = (status) => {
  const numericStatus = parseStatus(status);
  if (Number.isNaN(numericStatus)) {
    return 'event_status.error_other';
  }

  return STATUS_TRANSLATION_KEYS[numericStatus] ?? 'event_status.error_other';
};
